module.exports = __webpack_public_path__ + "media/images/device-patch-2562b0b6.png";